export default __webpack_public_path__ + "static/media/sbu-2021-m700b-galleryimages-2-210129.e2c208b3.jpg";